import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { RagStatus } from './useProjects';

export interface DeliveryProject {
  id: string;
  name: string;
  customerId: string | null;
  customerName: string;
  opportunityId: string | null;
  opportunityTitle: string | null;
  status: string;
  currentScopingStage: string | null;
  healthStatus: RagStatus;
  healthNotes: string | null;
  totalCost: number;
  totalAdjustedDays: number;
  currency: 'GBP' | 'USD' | 'EUR';
  engagementStartDate: string | null;
  scopingLeadName: string | null;
  deliveryLeadName: string | null;
  accountDirectorName: string | null;
}

export interface DeliveryCustomer {
  id: string;
  name: string;
  projects: DeliveryProject[];
  totalValue: number;
  totalDays: number;
  projectCount: number;
}

export interface DeliveryOverview {
  customers: DeliveryCustomer[];
  summary: {
    totalProjects: number;
    totalCustomers: number;
    totalValue: number;
    totalDays: number;
    byHealth: {
      green: number;
      amber: number;
      red: number;
      na: number;
    };
  };
}

export function useDeliveryOverview() {
  return useQuery({
    queryKey: ['delivery', 'overview'],
    queryFn: () => api.get<DeliveryOverview>('/delivery/overview'),
    staleTime: 60 * 1000,
  });
}
